export var CallPatientStatus;
(function (CallPatientStatus) {
    CallPatientStatus["ACCEPTED"] = "angenommen";
    CallPatientStatus["PENDING"] = "ausstehend";
    CallPatientStatus["DECLINED"] = "abgelehnt";
})(CallPatientStatus || (CallPatientStatus = {}));
export var CallPatientService;
(function (CallPatientService) {
    CallPatientService["GROUP"] = "KG-Gruppe";
    CallPatientService["SINGLE"] = "KG-Einzel";
})(CallPatientService || (CallPatientService = {}));
//# sourceMappingURL=call-patient.enum.js.map